import { render } from "./MessengerOnboardingModal.vue?vue&type=template&id=461dbe2c&scoped=true&ts=true"
import script from "./MessengerOnboardingModal.vue?vue&type=script&lang=ts"
export * from "./MessengerOnboardingModal.vue?vue&type=script&lang=ts"

import "./MessengerOnboardingModal.vue?vue&type=style&index=0&id=461dbe2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461dbe2c"]])

export default __exports__